import {initialLocale} from '@/translations';

export default async ({next, store, i18n, from, to}: any) => {
	const routeLocale = (from.name && from.name.indexOf('-en') > -1) || (to.name && to.name!.indexOf('-en') > -1) ? 'en' : null;
	const locale = from.params!.locale || to.params!.locale || routeLocale || initialLocale;

	store.dispatch('updateLocale', locale);
	i18n.locale = locale;

	return next();
}
